import React, { useState } from "react";
import { Modal } from "./Modal";
import { Button } from "./Button";
import { Input } from "./Input";

interface ManagerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (credentials: {
    username?: string;
    password?: string;
    role?: "manager";
  }) => void;
  error?: string;
  isLoading?: boolean;
}

export const ManagerModal: React.FC<ManagerModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  error,
  isLoading = false,
}) => {
  const [managerPassword, setManagerPassword] = useState("");

  const handleSubmit = () => {
    if (managerPassword.trim()) {
      onSubmit({
        username: "stch", // Hardcoded username
        role: "manager", // Hardcoded role
        password: managerPassword,
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !isLoading) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleClose = () => {
    if (isLoading) return; // Prevent closing while loading

    setManagerPassword(""); // Clear password when closing
    onClose();
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setManagerPassword(e.target.value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Manager Authentication"
      showCloseButton={!isLoading}
      footer={
        <>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isLoading || !managerPassword.trim()}
          >
            {isLoading ? "Authenticating..." : "Login"}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <Input
          type="password"
          value={managerPassword}
          onChange={handlePasswordChange}
          onKeyDown={handleKeyDown}
          placeholder="Enter password"
          error={error}
          disabled={isLoading}
          autoFocus
        />

        {/* Loading indicator */}
        {isLoading && (
          <div className="flex items-center justify-center py-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
            <span className="ml-2 text-sm text-gray-600">
              Authenticating...
            </span>
          </div>
        )}
      </div>
    </Modal>
  );
};
